module.exports = __webpack_public_path__ + "f08281bb79d9a46e53ecf01bb465c9d6.MP3";